import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import Loader from 'components/sales/Loader/loader';

const siteInformationInputs = {
  projectId: '',
};

const SiteInformationForm = ({
  isLoading = false,
  
  siteInformationData,
  
  showFilter='block',
}) => {
  const [siteInfoData, setSiteInfoData] = useState(siteInformationInputs);
  const [isEmptyForm, setIsEmptyForm] = useState(true);

 

  const onSubmitHandle = (e) => {
    e.preventDefault();
    let isValue = false;
    for (const key in siteInfoData) {
      if (siteInfoData[key]) {
        isValue = true;
      }
    }
    if (isValue) {
      setIsEmptyForm(true);
      siteInformationData(siteInfoData);
    } else setIsEmptyForm(false);
  };

  return (
    
    <form className="create-ticket-form" onSubmit={(e) => onSubmitHandle(e)}
      style={{'display':showFilter}}
    >
        <>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <ConstantInput
              label={localization.projectId}
              value={siteInfoData.projectId}
              type="text"
              handleChange={(val) =>
                setSiteInfoData({ ...siteInfoData, projectId: val })
              }
          />
          </div>
        
          <div className="col-md-3 col-sm-12">
            <button className="btn btn-primary" type="submit">
              {localization.getData}
            </button>
          </div>
        </div>
      

      {!isEmptyForm && (
        <div className="form-group full-width">
          <p className="error d-block">{localization.siteInfoError}</p>
        </div>
      )}
      
      <Loader isLoading={isLoading} />
      </>
    </form>
    
  );
 
};

export default SiteInformationForm;
